<script lang="ts">
  import "../../app.css";
  interface Props {
    css?: string;
  }

  let { css = "w-6 h-6 fill-[#566789]" }: Props = $props();

</script>

<svg class="{css}" viewBox="0 0 24 24"  width="24" height="24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
  <path d="M12 2C6.5 2 2 6.58 2 12.18V20.07C2 21.33 2.75 21.67 3.67 20.83L4.67 19.92C5.04 19.58 5.64 19.58 6.01 19.92L8.01 21.75C8.38 22.09 8.98 22.09 9.35 21.75L11.35 19.92C11.72 19.58 12.32 19.58 12.69 19.92L14.69 21.75C15.06 22.09 15.66 22.09 16.03 21.75L18.03 19.92C18.4 19.58 19 19.58 19.37 19.92L20.37 20.83C21.29 21.67 22.04 21.33 22.04 20.07V12.18C22 6.58 17.5 2 12 2ZM12 6.62C13.31 6.62 14.38 7.69 14.38 9C14.38 10.31 13.31 11.38 12 11.38C10.69 11.38 9.62 10.31 9.62 9C9.62 7.69 10.69 6.62 12 6.62ZM16.45 14.6C15.14 15.58 13.57 16.07 12 16.07C10.43 16.07 8.86 15.58 7.55 14.6C7.22 14.35 7.15 13.88 7.4 13.55C7.65 13.22 8.12 13.15 8.45 13.4C10.54 14.97 13.46 14.97 15.55 13.4C15.88 13.15 16.35 13.22 16.6 13.55C16.85 13.88 16.78 14.35 16.45 14.6Z"/>
</svg>
